<template>
  <div class="audit">
    <div class="audit_title">
      - Welcome -
    </div>
    <!-- wait -->
    <div class="audit_content" v-show="auditShow == 'wait'">
      <h1>資料已送出，請耐心等待審核^ ^</h1>
      <!-- 验证 -->
      <div class="audit_wait" v-show="!waitShow">
        <p>您登記的銀行帳號將會收到新台幣1元整的驗證匯款</p>
        <p class="audit_p">該筆轉帳資料帶有一組<span>4位數</span>的轉帳備注（附言）驗證碼</p>
        <p>請刷存折或登入網銀查看該組驗證碼後填入下方空格內</p>
        <el-input class="audit_input" v-model="auditVal" maxlength="4" clearable></el-input>
        <el-button type="primary" @click="waitShowBtns()">發送驗證</el-button>
        <p class="audit_service">請耐心等待驗證匯款，24小時後若仍未收到驗證匯款，請聯絡<span>線上客服</span></p>
      </div>
      <!-- 發送驗證 -->
      <div class="audit_wait" v-show="waitShow">
        <p>等待的時間歡迎逛逛<span class="audit_go_home" @click="goHome()">台易購商城</span>❤</p>
        <p class="wait_p">萬件好物等著您，也別忘了確認最新活動訊息哦！</p>
      </div>
    </div>
    <!-- defeated -->
    <div class="audit_content" v-show="auditShow == 'defeated'">
      <h1>審核失敗，<span>點擊此處修改資料</span></h1>
      <div class="audit_defeated">
        <dl>
          <dt><span>●</span>營業登記證</dt>
          <dd>請提供至少200萬像素（1600*1200）的清晰圖片</dd>
        </dl>
        <dl>
          <dt><span>●</span>身份證</dt>
          <dd>請提供至少100萬像素（1280*960）的清晰圖片</dd>
        </dl>
        <!-- audit_defeated -->
      </div>
      <!-- defeated -->
    </div>

    <!-- audit -->
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Audit',
  props: {
  },
  data() {
    return {
      auditVal: '',
    }
  },
  components: {
  },
  computed: {
    auditShow(){
      return this.$store.state.auditShow;
    },
    waitShow(){
      return this.$store.state.waitShow;
    }
  },
  methods: {
    // 查詢
    waitShowBtns() {
      if(this.$store.state.number != null){

        if(this.auditVal == this.$store.state.number){
          axios.get(this.$store.state.axiosAuditVerificationUrl, {
              params:{
                type: 1,
                uid: this.$store.state.registerList.uid
              }
          }).then((res) => {
            // console.log(res);
          })
          this.$message({
            showClose: true,
            message: '驗證成功，歡迎您！',
            type: 'success',
            duration: 1000
          });
          this.$router.push("/login/agreement");

        } else {
          this.$message({
            showClose: true,
            message: '驗證碼錯誤，請重新輸入',
            type: 'error',
            duration: 1000
          });
        }

      }
    },
    goHome(){
      this.$router.push("/");
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* wait */
  .audit {
      box-sizing: border-box;
      border: 2px solid #bbbbbb;
      font-size: 17px;
      color: #777777;
      overflow: hidden;
      width: 970px;
      margin: 0 auto;
      margin-bottom: 42px;
    }
  .audit_title {
    height: 55px;
    line-height: 55px;
    background: #f2f2f2;
    text-align: center;
    font-weight: bold;
  }
  .audit_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .audit_content > h1 {
    font-size: 29px;
    font-weight: bold;
    margin-top: 36px;
    margin-bottom: 40px;
  }
  .audit_content > h1 > span {
    color: #7c9cec;
    display: inline-block;
    padding: 16px 0;
    border-bottom: 3px solid #7c9cec;
  }
  .audit_content p {
    font-size: 11px;
  }
  .audit_content .audit_p {
    margin: 26px 0;
  }
  .audit_p span {
    color: #e73262;
  }
  .audit_wait {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .audit_input {
    width: 180px;
    margin: 36px 0;
  }
  .audit_service {
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .audit_service span {
    color:#9fb5f0;
  }
  .audit_go_home {
    color:#9fb5f0; 
    cursor: pointer;
  }
  .wait_p {
    margin-top: 26px;
    margin-bottom: 48px;
  }
/* defeated */
  .audit_defeated {
    box-sizing: border-box;
    font-size: 13px;
    border: 2px solid #bbbbbb;
    width: 443px;
    min-height: 183px;
    margin-bottom: 36px;
    padding: 12px;
  }
  .audit_defeated dt{
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .audit_defeated dt {
    font-weight: bold;
  }
  .audit_defeated dt span {
    font-size: 30px;
  }
  .audit_defeated dd {
    text-indent: 18px;
    margin-bottom: 16px;
  }
</style>
